<template lang="pug">
Card.selections-card
    template(#header)
        .title {{ $t('selections.successMPRN.title') }}
    template(#content)
        .mprn-successful 
            .mprn-n MPRN:
                span {{ mprn }}
            Button.mprn-button(@click="resetMPRN()" :label="$t('selections.successMPRN.button')")
</template>
<script lang="ts">
import { useSelections } from "@/store/selections";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import Card from "primevue/card";
import Button from "primevue/button";

export default defineComponent({
  name: "SuccessMPRN",
  components: {
    Card,
    Button,
  },
  setup() {
    const selections = useSelections();
    const { mprn } = storeToRefs(selections);
    const { resetMPRN } = selections;

    return {
      mprn,
      resetMPRN,
    };
  },
});
</script>
<style scoped lang="scss">
.mprn-successful {
  display: flex;
  justify-content: space-between;
  .mprn-n {
    font-size: 1.2rem;
    span {
      margin-left: 1rem;
      font-size: 1.4rem;
      font-weight: 500;
    }
  }
}
</style>
